import { Injectable } from '@angular/core';
import { Feed } from 'src/app/models/Feed';
import { ToastService } from 'src/app/util/toast.service';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';
import { ReactionService } from './reaction.service';
import { Reaction } from 'src/app/models/Reaction';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/util/alert.service';
import { WhatsappService } from '../whatsapp.service';

@Injectable({
  providedIn: 'root',
})
export class FeedService {
  selectedType = "Info";
  typeList: string[] = ["Info", "Condolence", "Event", "Bhawan", "Business", "Job", "Marriage"];
  typeTranslationList: string[] = ["जानकारी", "शोक", "कार्यक्रम", "भवन", "व्यापार", "नौकरी", "विवाह"];
  typeIconList: string[] = ["win.png", "feed_shok.jpeg", "feed_event.png", "bhawan.png", "feed_biz.png", "news_job.png", "feed_marriage.png"];
  statusList: string[] = ["Draft", "Publish", "Amendment Request", "Finish", "Unpublish", "Reject", "Delete"];
  feed: Feed = new Feed;
  feedList: Feed[] = [];
  lastImageSize: any;

  constructor(private backEnd: BackEndService, private router: Router,
    private auth: AuthService, private toast: ToastService, private whatsApp: WhatsappService,
    private reactionService: ReactionService, private alert: AlertService) {
    this.auth.getLoggedInEmployee();
  }
  getFeed(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.getSingle("feed", [[variable, id]]).then((feed: Feed) => {
        this.jsonParsing(feed);
        if (!feed.image_urls || feed.image_urls.length == 0) {
          feed.image_urls = [];
          feed.image_urls.push(null);
        }
        this.feed = feed;
        resolve(feed);
      })
    })
  }

  jsonParsing(feed: Feed) {
    if (feed.creator && ((typeof feed.creator === 'string'))) {
      feed.creator = JSON.parse(feed.creator)
    }
    if (feed.image_urls && ((typeof feed.image_urls === 'string'))) {
      feed.image_urls = JSON.parse(feed.image_urls)
    }
    if (feed.json_details && ((typeof feed.json_details === 'string'))) {
      feed.json_details = JSON.parse(feed.json_details)
    }
    if (feed.reaction_count) {
      if ((typeof feed.reaction_count === 'string')) {
        feed.reaction_count = JSON.parse(feed.reaction_count)
      }
      feed.reactionKeys = [];
      const sortedArray = Object.entries(feed.reaction_count).sort((a: any, b: any) => b[1] - a[1]);
      for (let [key] of sortedArray) {
        feed.reactionKeys.push(key);
      }
      feed.reaction_count = Object.fromEntries(sortedArray);
    }
  }


  resetFeed() {
    this.feedList = [];
  }

  getAllFeed(limit = 2, index = 0) {
    return new Promise((resolve) => {
      let query = [["type", this.selectedType], ["business_id", this.auth.loggedInEmployee.business_id]]
      if (!this.auth.loggedInEmployee.assigned_area || ((this.auth.loggedInEmployee.assigned_area + '').length < 3)) {
        query.push(["status.eq.Publish,created_by.eq." + this.auth.loggedInEmployee.id, "", "or"])
      }

      this.backEnd.searchObject("feed", query, index, limit, "created_at", true).then((feedList: Feed[]) => {
        if (index === 0) {
          this.feedList = feedList || [];
        } else if (feedList) {
          this.feedList.push(...feedList);
        }

        if (this.feedList) {
          for (let feed of this.feedList) {
            this.jsonParsing(feed);
          }
        }

        // Demo feeds only on first page
        if (index === 0) {
          this.getDemoFeeds().then((demoList: Feed[]) => {
            if (demoList) {
              for (let demo of demoList) {
                this.jsonParsing(demo);
                // Check if already exists to avoid duplicates
                if (!this.feedList.find(f => f.id === demo.id)) {
                  this.feedList.push(demo);
                }
              }
            }
          });
        }
        resolve(feedList?.length || 0);
      })
    })
  }

  getDemoFeeds() {
    return new Promise((resolve) => {
      this.backEnd.searchObject("feed", [["business_id", "Vanshavali"], ["type", this.selectedType]], 0, 10, "created_at", true).then((demoList) => {
        resolve(demoList);
      });
    })
  }

  saveObject(feed?: Feed) {
    return new Promise((resolve) => {
      if (!feed) {
        feed = this.feed;
      }
      if (!feed.id) {
        feed.created_by = this.auth.loggedInEmployee.id;
        feed.business_id = this.auth.loggedInEmployee.business_id;
        feed.creator = {
          url: this.auth.loggedInEmployee.user.url,
          name: this.auth.loggedInEmployee.user.name,
          role: this.auth.loggedInEmployee.access,
        };
      }
      let obj = { ...feed };
      delete obj.reactionKeys;
      if (Array.isArray(obj.image_urls)) {
        obj.image_urls = obj.image_urls.filter(url => url);
      }
      this.backEnd.saveObject("feed", obj).then((response: any) => {
        if (response) {
          feed.id = response.id; // Correctly update the ID for notifications
          this.toast.success("Feed Saved");
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  getFeedForUser() {
    return new Promise((resolve) => {
      this.backEnd.getSingle(this.selectedType.toLowerCase(), [["emp_id", this.auth.loggedInEmployee.id], ["business_id", this.auth.loggedInEmployee.business_id]]).then((feed) => {
        if (feed) {
          this.feed = feed;
          console.log(this.feed);
          resolve(this.feed);
        }
      });
    });
  }

  async sendMessage(feed: Feed) {
    var regExp = /[a-zA-Z]/g;

    const trimmed = this.reactionService.reaction.reaction.trim();

    // Check if the trimmed message is exactly one emoji from the list
    if (this.reactionService.emojiList.includes(trimmed)) {
      this.reactionService.reaction.type = 'Emoji';
    } else {
      this.reactionService.reaction.type = 'Comment';
    }
    // console.log(this.reaction.reaction);
    this.reactionService.reaction.feed_id = feed.id;
    this.reactionService.reaction.creator = { url: this.auth.loggedInEmployee.user.url, name: this.auth.loggedInEmployee.user.name, access: this.auth.loggedInEmployee.access }
    let oldEmoji = null;
    if (this.reactionService.reaction.type == 'Emoji') {
      let existingReactionList: Reaction[] = await this.reactionService.getUserReaction(this.auth.loggedInEmployee.id, feed.id, 'Emoji')
      console.log(existingReactionList);
      if (existingReactionList.length > 0) {
        oldEmoji = existingReactionList[0].reaction;
        this.reactionService.reaction.id = existingReactionList[0].id;
      }
    }
    this.reactionService.saveObject().then(() => {
      if (!feed.reaction_count) feed.reaction_count = {};

      if (this.reactionService.reaction.type === 'Comment') {
        this.updateReactionCount(feed, '💬', 1);
      } else {
        if (oldEmoji) this.updateReactionCount(feed, oldEmoji, -1);
        this.updateReactionCount(feed, this.reactionService.reaction.reaction, 1);
      }

      this.sortReactionCount(feed);
      this.reactionService.reaction = new Reaction();
      this.saveObject(feed);
    });
  }
  openDetails(id) {
    this.router.navigate(['post-details/' + id]);
  }

  private updateReactionCount(feed: Feed, emoji: string, delta: number) {
    if (!emoji) return;
    feed.reaction_count[emoji] = (feed.reaction_count[emoji] || 0) + delta;
    if (feed.reaction_count[emoji] <= 0) delete feed.reaction_count[emoji];
  }

  private sortReactionCount(feed: Feed) {
    const sortedArray = Object.entries(feed.reaction_count).sort((a: any, b: any) => b[1] - a[1]);
    feed.reactionKeys = sortedArray.map(([key]) => key);
    feed.reaction_count = Object.fromEntries(sortedArray);
  }

  public async share(feed: Feed) {
    // if (navigator.share) {

    //   const shareData: ShareData = {
    //     title: feed.header,
    //     text: feed.description,
    //     url: 'https://vanshavali.web.app/vansh/feed',
    //   };
    //   if (feed.image_urls && feed.image_urls.length > 0) {
    //     const response = await fetch(feed.image_urls[0]);
    //     const blob = await response.blob();

    //     // Create File from Blob
    //     const file = new File([blob], 'vanshavali.jpg', { type: blob.type });
    //     shareData.files = [file]
    //   }
    //   navigator.share(shareData).then(() => console.log('Shared successfully'))
    //     .catch((err) => console.error('Sharing failed', err));
    // } else {
    //   this.toast.warning('Web Share API not supported on this browser.');
    // }
    let message = "";
    if (feed.image_urls && feed.image_urls.length > 0) {
      message += feed.image_urls[0] + "\n\n";
    }
    message += feed.header + "\n\n" + feed.description + "\n\n";
    console.log(feed.event_date);
    if (feed.event_date) {
      message += "Date: " + (feed.event_date + "").split('.')[0] + "\n\n";
    }
    message += "To view the complete details click \n\nhttps://vanshavali.web.app/post-details/" + feed.id + "\n\n";
    this.whatsApp.sendMessage(null, message);
  }

  deleteObject(feed: Feed) {
    return new Promise((resolve) => {
      this.alert.showAlert("Delete Feed", "Are you sure you want to delete this feed?").then((result) => {
        this.backEnd.deleteObject("reaction", feed.id, "feed_id").then(() => {
          this.backEnd.deleteObject("feed", feed.id).then((response) => {
            if (response) {
              this.toast.success("Feed Deleted");
              this.feedList = this.feedList.filter(f => f.id !== feed.id);
              resolve(true);

            } else {
              resolve(false);
            }
          });
        });
      });
    });
  }

}
